import { Card, CardContent, CardFooter, Button } from "@pushpress/pushpress-ui";
import { CircleCheck } from "lucide-react";

export default function SuccessScreen({ onClose }: { onClose: () => void }) {
  return (
    <div className="tw-h-auto tw-w-auto tw-flex tw-items-center tw-justify-center tw-p-4">
      <Card className="tw-w-full tw-max-w-lg tw-mx-auto">
        <CardContent className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-10">
          <div className="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-pt-6">
            <div className="tw-rounded-full tw-bg-green-100 tw-p-4 tw-mb-2">
              <CircleCheck className="tw-h-10 tw-w-10 tw-text-success" />
            </div>
            <h2 className="tw-text-2xl tw-font-semibold tw-text-neutral-800">
              Payment method added
            </h2>
            <p className="tw-text-base tw-text-neutral-500 tw-mt-1 tw-text-center">
              Your payment method has been successfully added and is now
              available for future payments.
            </p>
          </div>
        </CardContent>
        <CardFooter className="tw-flex tw-justify-center tw-border-t tw-pt-6">
          <Button size="lg" className="tw-w-full" onClick={onClose}>
            Close
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
